export default __webpack_public_path__ + "static/media/KZ.T.15.2499 black.2ea10a28.svg";